export default function InfoCircle({ heading, text, variant, color }) {
    return (
        <div
            className="bg-primary-gold w-fit flex flex-col items-center justify-center gap-y-1"
            style={{ height: "200px", width: "200px", borderRadius: "100%" }}
        >
            <div
                className={`font-poppins text-center font-light ${
                    variant === 1 ? "text-4xl" : "text-2xl"
                } ${color === "blue" ? "text-primary-blue" : "text-primary-white"}`}
            >
                {heading}
            </div>
            <div
                className={`font-poppins text-center font-light ${
                    variant === 1 ? "text-xl" : "text-lg"
                } ${color === "blue" ? "text-primary-blue" : "text-primary-white"}`}
            >
                {text}
            </div>
        </div>
    );
}
